import type { SortingState } from '@tanstack/react-table';
import type { EfaxSearchState } from '../types';

export const DEFAULT_SEARCH: EfaxSearchState = {
  documentName: '',
  documentId: '',
  receivedAtStart: undefined,
  receivedAtEnd: undefined,
  documentStatus: '',
  outputFileName: '',
  outputCategoryFilterMode: 'include',
  outputDocumentCategories: [],
  profileFilterMode: 'exclude',
  excludeOrganizationProfileIds: [],
  patientName: '',
  patientDob: undefined,
  patientReferenceId: '',
  patientKey: '',
  providerName: '',
  providerFacilityName: '',
  providerType: '',
  receivingProviderName: '',
  receivingProviderFacilityName: '',
  receivingProviderType: '',
};

export const DEFAULT_SORTING: SortingState = [
  { id: 'receivedAt', desc: true },
  { id: 'priority', desc: false },
];

export const DEFAULT_PAGINATION = { page: 0, pageSize: 10 } as const;
